import React from 'react';
import './WordCloud.css'

const WordCloudComponent = ({keywords}) => {
  const sortedKeywords = Object.entries(keywords)
    .map(([text, value]) => ({ text, value }))
    .sort((a, b) => b.value - a.value);

  const maxValue = Math.max(...sortedKeywords.map(k => k.value));

  return (
    <div className="word-cloud">
    <h3 className="ratingText">AI keyword analysis</h3>
      <div className="keyword-list">
        {sortedKeywords.map((keyword) => (
        <div key={keyword.text} className='keyword-item-container'>
            <div className="keyword-item">
                <div className="keyword-text">
                {keyword.text}
                </div>
                <span className="keyword-count">
                {keyword.value}
                </span>
            </div>
            <div
                className="bar-fill"
                style={{ width: `${(keyword.value / maxValue) * 100}%` }}
              />
          </div>
        ))}
      </div>
    </div>
  );
};

export default WordCloudComponent;